export const BASE_ASSET_URL_PROD =
  'https://storage.googleapis.com/notable-prod-assets/previsit' as const;
export const BASE_ASSET_URL_DEV =
  'https://storage.googleapis.com/vivaa-dev-assets/previsit' as const;

export function getBaseAssetUrl(): string {
  return isLocalBuild() ? BASE_ASSET_URL_DEV : BASE_ASSET_URL_PROD;
}

export function getLoginUrl(): string {
  return `${getBaseStaffUrl()}/login`;
}

export function isLocalBuild(): boolean {
  return (
    window.location.protocol === 'http:' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
}

export function getBaseStaffUrl(): string {
  return isLocalBuild()
    ? 'http://localhost:3002/staff/app#'
    : `${window.location.origin}/staff/app#`;
}

export function getBaseAdminUrl(): string {
  return isLocalBuild()
    ? 'http://localhost:3001/admin/app#'
    : `${window.location.origin}/admin/app#`;
}
